import {
    CREATE_SMTP_SETUP_START,
    CREATE_SMTP_SETUP_SUCCESS,
    CREATE_SMTP_SETUP_ERROR,
    DELETE_SMTP_SETUP_START,
    DELETE_SMTP_SETUP_SUCCESS,
    DELETE_SMTP_SETUP_ERROR
} from '../../../constants';
import {
    getAllSmtpData,
    createSmtpSetup,
    deleteSmtpSetup as deleteMutation
} from '../../../lib/graphql';
import { closeSmtpSetupModal } from '../modalActions';
import showToaster from '../../../helpers/toasterMessages/showToaster';

export function createSmtpData({
    id,
    smtpName,
    smtpHost,
    smtpPort,
    smtpEmail,
    smtpSender,
    smtpSenderEmail,
    smtpPassword,
    currentPage
}) {
    return async (dispatch, getState, { client }) => {
        await dispatch({
            type: CREATE_SMTP_SETUP_START,
            payload: {
                createSmtpSetupLoading: true
            }
        });
        try {
            const { data } = await client.mutate({
                mutation: createSmtpSetup,
                variables: {
                    id,
                    smtpName,
                    smtpHost,
                    smtpPort,
                    smtpEmail,
                    smtpSender,
                    smtpSenderEmail,
                    smtpPassword
                },
                refetchQueries: [{ query: getAllSmtpData, variables: { currentPage } }]
            });

            if (data?.createSmtpSetup?.status === 200) {
                await dispatch({
                    type: CREATE_SMTP_SETUP_SUCCESS,
                    payload: {
                        createSmtpSetupLoading: false
                    }
                });
                dispatch(closeSmtpSetupModal());
                let requestMessage = id ? 'updateSmtpData' : 'addSmtpData'
                showToaster({ messageId: requestMessage, toasterType: 'success' })
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.createSmtpSetup?.errorMessage })
                await dispatch({
                    type: CREATE_SMTP_SETUP_ERROR,
                    payload: {
                        createSmtpSetupLoading: false,
                        error: data?.createSmtpSetup?.errorMessage
                    }
                });
            }
        } catch (error) {
            await dispatch({
                type: CREATE_SMTP_SETUP_ERROR,
                payload: {
                    createSmtpSetupLoading: false,
                    error
                }
            });
        }
    }
}

export function deleteSmtpSetup({ id }) {
    return async (dispatch, getState, { client }) => {
        await dispatch({
            type: DELETE_SMTP_SETUP_START,
            payload: {
                deleteSmtpSetupLoading: true
            }
        });

        try {

            const { data } = await client.mutate({
                mutation: deleteMutation,
                variables: {
                    id
                },
                refetchQueries: [{ query: getAllSmtpData }]
            });
            if (data?.deleteSmtpSetup?.status === 200) {
                await dispatch({
                    type: DELETE_SMTP_SETUP_SUCCESS,
                    payload: {
                        deleteSmtpSetupLoading: false
                    }
                });
                dispatch(closeSmtpSetupModal());
                showToaster({ messageId: 'deleteSmtpData', toasterType: 'success' })
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.deleteSmtpSetup?.errorMessage })
                await dispatch({
                    type: DELETE_SMTP_SETUP_ERROR,
                    payload: {
                        deleteSmtpSetupLoading: false,
                        error: data?.deleteSmtpSetup?.errorMessage
                    }
                });
            }
        } catch (error) {
            await dispatch({
                type: DELETE_SMTP_SETUP_ERROR,
                payload: {
                    deleteSmtpSetupLoading: false,
                    error
                }
            });
        }
    }
}